import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FieldResource } from "../../core/modules/openapi";
import { MatInputModule } from "@angular/material/input";
import { MatNativeDateModule } from "@angular/material/core";
import { Observable, of, switchMap } from "rxjs";

@Component({
  selector: "app-date",
  imports: [MatFormFieldModule, MatInputModule, MatDatepickerModule, MatNativeDateModule, ReactiveFormsModule, CommonModule],
  template: `
    <div class="app-input" *ngIf="visible | async; let isVisible">
      <mat-form-field class="demo-full-width margin-top" [formGroup]="group"
                      class="full-width-field">
        <mat-label>{{ field.displayName }}</mat-label>
        <input matInput [matDatepicker]="picker" readonly [formControlName]="field.name"
               [placeholder]="field.displayName">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker [disabled]="!field.enabled"></mat-datepicker>
        <mat-hint></mat-hint>
        <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
          <mat-error
            *ngIf="group.controls[field.name].hasError(validation.name.toLowerCase())">{{ validation.message }}
          </mat-error>
        </ng-container>
      </mat-form-field>
    </div>
  `,
  standalone: true,
  styleUrls: ['./date.component.sass']
})
export class DateComponent implements OnInit {
  field: FieldResource;
  group: FormGroup;
  subject: Observable<string>;
  visible: Observable<boolean>;

  constructor() { }
  ngOnInit() {
    //this.field.possibleValues = this.orderPipe.transform(this.field.possibleValues, 'name', false, true);
    this.visible = this.subject.pipe(switchMap(x => of(this.isVisible(x))));
  }

  isVisible(value:string)
  {
    if(this.field.visibilityGroup && this.field.visibilityGroup === value) {
      this.group.controls[this.field.name]?.enable();
      return true;
    } else if(!this.field.visibilityGroup) {
      this.group.controls[this.field.name]?.enable();
      return true;
    } else {
      this.group.controls[this.field.name]?.disable();
      return false;
    }
  }
}
